/* ===========================================================
   Highlight Active Filter Link Based on Current URL
   =========================================================== */
document.addEventListener("DOMContentLoaded", function () {
  const currentUrl = window.location.href;
  const filterLinks = document.querySelectorAll(".custom__Content a");

  filterLinks.forEach(link => {
    const href = link.getAttribute("href").split("#")[0];
    if (currentUrl.includes(href)) {
      link.classList.add("active");
    }
  });
});


/* ===========================================================
   Remove Transparent Header Only For Product Page (Mobile)
   =========================================================== */
document.addEventListener("DOMContentLoaded", () => {
  if (window.innerWidth <= 768 && window.location.pathname.includes("product")) {
    document
      .querySelectorAll("[allow-transparent-header]")
      .forEach(el => el.removeAttribute("allow-transparent-header"));
  }
});


/* ===========================================================
   Product Page Tab Horizontal Drag Scroll (Desktop)
   =========================================================== */
const slider2 = document.querySelector('.template-product .product-info__block-list .tab');

if (slider2) {
  let mouseDown = false;
  let startX = 0;
  let scrollLeft = 0;

  const startDragging = (e) => {
    mouseDown = true;
    startX = e.pageX - slider2.offsetLeft;
    scrollLeft = slider2.scrollLeft;
  };

  const stopDragging = () => {
    mouseDown = false;
  };

  const move = (e) => {
    if (!mouseDown) return;
    e.preventDefault();
    const x = e.pageX - slider2.offsetLeft;
    slider2.scrollLeft = scrollLeft - (x - startX);
  };

  // Enable if needed
  slider2.addEventListener("mousemove", move);
  slider2.addEventListener("mousedown", startDragging);
  slider2.addEventListener("mouseup", stopDragging);
  slider2.addEventListener("mouseleave", stopDragging);
}

  
/* ===========================================================
   Refresh Page on Variant Change (Only if Discount Exists)
   =========================================================== */
document.addEventListener("DOMContentLoaded", function() {
  // Listen for variant changes on all product forms
  document.querySelectorAll('form[is="product-form"]').forEach(form => {
    form.addEventListener('variant:change', function(event) {
      const variant = event.detail?.variant;
      if (variant) {
        // Check if product has discount by looking for discount-price element or sale-price with discount data
        const formId = form.id;
        let hasDiscount = false;
        
        // Check for discount-price element
        if (document.querySelector('discount-price') !== null) {
          hasDiscount = true;
        }
        
        // Check for sale-price with discount percentage > 0
        const salePriceWithDiscount = document.querySelector(`sale-price[data-discount-percentage]`);
        if (salePriceWithDiscount) {
          const discountPercentage = parseFloat(salePriceWithDiscount.getAttribute('data-discount-percentage')) || 0;
          if (discountPercentage > 0) {
            hasDiscount = true;
          }
        }
        
        if (hasDiscount) {
          // Update URL with variant parameter and refresh
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.location.href = url.toString();
        }
      }
    });
  });
});
